import {AbstractAdminEntityService} from "./AbstractAdminEntityService";
import {AdminEntityService} from "./AdminEntityService";
import {
    ItemView,
    AwardItemRequest,
    ItemListResponse,
    ListRequest,
    RevokeItemRequest
} from "../../../generated/protocol";
import {injectable} from "inversify";

export const ITEM_SERVICE_NAME = "itemService";

export interface ItemService extends AdminEntityService<ItemView> {
    awardAll(request: AwardItemRequest): Promise<{}>;

    listByCategory(category: String): Promise<{}>;

    revokeItem(request: RevokeItemRequest): Promise<{}>;
}

@injectable()
export class ItemServiceImpl extends AbstractAdminEntityService<ItemView, ItemListResponse> {

    constructor() {
        super("/item");
    }

    awardAll(request: AwardItemRequest): Promise<{}> {
        return this.http.doPost(this.entityPath + "/awardAll", request);
    }

    listByCategory(category: String): Promise<{}> {
        return this.http.doGet(this.entityPath + "/list-by-category/" + category);
    }

    revokeItem(request: RevokeItemRequest): Promise<{}> {
        return this.http.doPost(this.entityPath + "/revoke", request);
    }
}



// WEBPACK FOOTER //
// ./src/app/service/admin/ItemService.ts